import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'index',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Index.vue') }],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [{ path: '', component: () => import('pages/Login.vue') }],
  },
  {
    path: '/pdpa',
    name: 'pdpa',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/PdpaForm.vue') }],
  },
  {
    path: '/tracking',
    name: 'tracking',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Tracking.vue') }],
  },
  {
    path: '/myprofile',
    name: 'myprofile',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/EditProfile.vue') }],
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/ChangePassword.vue') },
    ],
  },
  {
    path: '/member',
    name: 'member',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Member.vue') }],
  },
  {
    path: '/campaign/:id',
    name: 'campaign',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/CampaignDetail.vue') },
    ],
  },
  {
    path: '/consents-info',
    name: 'consents-info',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Consents.vue') }],
  },
  {
    path: '/consents',
    name: 'consents',
    component: () => import('layouts/ConsentLayout.vue'),
    children: [{ path: '', component: () => import('pages/Consents.vue') }],
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Wallet.vue') }],
  },
  {
    path: '/term',
    name: 'term',
    component: () => import('layouts/ConsentLayout.vue'),
    children: [{ path: '', component: () => import('pages/Terms.vue') }],
  },
  {
    path: '/not-verified',
    name: 'not-verified',
    component: () => import('layouts/NotVerifedLayout.vue'),
    children: [{ path: '', component: () => import('pages/NotVerified.vue') }],
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('layouts/ConsentLayout.vue'),
    children: [{ path: '', component: () => import('pages/Privacy.vue') }],
  },
  {
    path: '/term-info',
    name: 'term-info',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Terms.vue') }],
  },
  {
    path: '/privacy-info',
    name: 'privacy-info',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/Privacy.vue') }],
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/SignOut.vue') }],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  },
]

export default routes
